import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import CloseIcon from "../assets/img/closeIcon.svg";
import ReportOverview from "../pages/landlord/ReportOverview";
import useTranslator from "../hooks/useTranslator";
import { Button } from "./design";

const ReportOverviewDrawer = ({
  isOpen,
  onClose,
  queryParameters,
  reportKey,
  onResolutionChange,
}) => {
  const { workspaceId } = useParams();
  const { _t } = useTranslator();

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  const props = useMemo(() => {
    if (!queryParameters) return {};
    const params =
      queryParameters instanceof URLSearchParams
        ? queryParameters
        : new URLSearchParams(queryParameters);
    return {
      property_id: params.get("property"),
      sharedprofileid: params.getAll("sharedprofileid"),
      rent: params.get("rent"),
      redirectUrl: params.get("redirectUrl"),
      selection: params.get("selection"),
      awardSnapshotCompleted: params.get("awardSnapshotCompleted") === "true",
      historyEventId: params.get("historyEventId"),
    };
  }, [queryParameters]);

  const openInNewPage = () => {
    const qs =
      queryParameters instanceof URLSearchParams
        ? queryParameters.toString()
        : (queryParameters || "").replace(/^\?/, "");
    const url = `${workspaceId ? `/${workspaceId}` : ""}/report-overview?${qs}`;
    window.open(url, "_blank");
  };

  return (
    <div
      className={`wrapper-modal report-overview-drawer-wrapper ${
        isOpen ? "open" : ""
      }`}
    >
      <div
        className={`report-overview-drawer ${isOpen ? "open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="report-overview-drawer__header">
          <Button variant="link" onClick={openInNewPage}>
            {_t("openInNewPage")}
          </Button>
          <img
            src={CloseIcon}
            alt=""
            className="report-overview-drawer__close"
            onClick={onClose}
          />
        </div>
        <div className="report-overview-drawer__content">
          <ReportOverview
            key={reportKey}
            {...props}
            onResolutionChange={onResolutionChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportOverviewDrawer;
